import React from 'react';
import Table from '../../components/common/Table';
import { CompetitionExerciseDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface CompetitionExerciseTableProps {
  data: CompetitionExerciseDTO[];
  handleEdit: (row: CompetitionExerciseDTO) => void;
  handleDelete: (row: CompetitionExerciseDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CompetitionExerciseTable: React.FC<CompetitionExerciseTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'exerciseSpecificTitle',
        },

        {
          label: 'Exercise',
          key: 'competitionExerciseTypeId',
          render: (row: CompetitionExerciseDTO) => (
            <span>{row.competitionExerciseType?.title}</span>
          )
        },

        {
          label: 'Specific Exercise',
          key: 'exerciseSpecificId',
          render: (row: CompetitionExerciseDTO) => (
            <span>{row.exerciseSpecific?.title}</span>
          )
        },

        {
          label: 'Class',
          key: 'competitionClassTypeId',
          render: (row: CompetitionExerciseDTO) => (
            <span>{row.competitionClassType?.title}</span>
          )
        },

        {
          label: 'Gender',
          key: 'genderId',
          render: (row: CompetitionExerciseDTO) => (
            <span>{row.gender?.title}</span>
          )
        },

        {
          label: 'Active',
          key: 'isActive',
          render: (row: CompetitionExerciseDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },

        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CompetitionExerciseTable;
